import React from 'react';
import PropTypes from 'prop-types';
import {ColorSelectQuestionContent} from '@learningblocks/storybook-components';
import {Utilities} from '@learningblocks/exp-constants';
import {QuestionWrapper} from '../Components/QuestionWrapper';
import {MainTitle} from '../Components/MainTitle';
import {Footer} from '../Components/Footer';
import {TotalAttempts} from '../Components/TotalAttempts';
import {SubmitButton} from '../Components/SubmitButton';
import './style.scss';

const {hasAttempts} = Utilities;

/**
 * ColorSelection
 *  - Question Component for user to select the correct colors for each option
 */
export function ColorSelection(props) {
  const onColorSelect = (params) => {
    props.onColorSelect(params);
  };

  const isSubmitDisabled = () => {
    if (props.complete) return true;
    else if (props.submitted) return true;
    else if (hasAttempts(props.totalAttempts)) return false;
    else return false;
  };

  const wrapperClass = ` colorSelectionQuestion ${props.className}`;
  return (
    <QuestionWrapper className={wrapperClass}>
      <MainTitle
        title='Prectiction Question'
        className='colorSelectionQuestion__mainTitle'
      />
      <ColorSelectQuestionContent
        question={props.question}
        options={props.options}
        onColorSelect={onColorSelect}
      />
      <Footer className='colorSelectionQuestion__footer'>
        <TotalAttempts
          totalAttempts={props.totalAttempts}
          className='colorSelectionQuestion__footer__totalAttempts'
        />
        <SubmitButton disabled={isSubmitDisabled()} onSubmit={props.onSubmit} />
      </Footer>
    </QuestionWrapper>
  );
}

ColorSelection.propTypes = {
  /**
   * Title to display on top
   */
  headTitle: PropTypes.string,
  /**
   * Question text
   */
  question: PropTypes.string,
  /**
   * Options for the question
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Label for option
       */
      optionLabel: PropTypes.string.isRequired,
      /**
       * Data needed to render optionTube
       */
      optionTube: PropTypes.shape({
        /**
         * Type of the tube Image
         */
        type: PropTypes.oneOf(['TUBE', 'GLASS_TUBE']).isRequired,
      }),
      /**
       * List of Checkboxes to display for option
       */
      checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
      /**
       * data to show feedback
       */
      feedback: PropTypes.shape({
        /**
         * Boolean to set if feedback should be displayed
         */
        showFeedback: PropTypes.bool.isRequired,
        /**
         * Boolean to set if feedback should be correct/incorrect state
         */
        isCorrect: PropTypes.bool,
        /**
         * Message to display on feedback
         */
        message: PropTypes.string,
      }).isRequired,
    })
  ),
  /**
   * Function to execute when color selected in checkbox
   */
  onColorSelect: PropTypes.func,
  /**
   * Functon to execute on click Submit Button
   */
  onSubmit: PropTypes.func,
  /**
   * Boolean to set if Question Complete
   */
  complete: PropTypes.bool,
  /**
   * Booleant to set if in submitted state
   */
  submitted: PropTypes.bool,
  /**
   *  Value for numbers of attempts left in the quesiton
   */
  totalAttempts: PropTypes.number,
  /**
   * className to be set for ColorSelection
   */
  className: PropTypes.string,
};

ColorSelection.defaultProps = {
  headTitle: 'Question',
  className: '',
};
